export enum AppLayer {
    FILTER = 45,
    NAVBAR = 50,
    POPOVER = 60,
    MODAL = 1000,
}
